import React, {useState, useEffect, useContext} from 'react';
import InputWithError from 'components/InputWithError';
import {Button, CustomInput, ModalFooter, ModalBody, Row, Col} from 'reactstrap';
import SpinnerButton from 'components/SpinnerButton';
import {createProduct, updateProductById, getProductById} from 'utils/api';
import Loader from 'components/Loader';
import {ErrorContext} from 'contexts/ErrorContext';
import {toast} from 'react-toastify';

const ProductForm = ({toggle, type, refreshList, existingProduct}) => {
    const {handleErrors} = useContext(ErrorContext);

    const [submitting, setSubmitting] = useState(false);
    const [name, setName] = useState('');
    const [populatingExistingFields, setPopulatingExistingFields] = useState(true);
    const [error, setError] = useState(null);
    const [sourceOptions, setSourceOptions] = useState({
        twitterAccount: false,
        twitterKeyword: false,
        twitterHashtag: false,
        twitterMentions: false,
        twitterCashtag: false,
        googleOzmosys: false,
        facebook: false,
        rss: false,
        instagram: false,
        youtube: false,

    });
    const [chartOptions, setChartOptions] = useState({
        volumeChart: false,
        keywordChart: false,
        sentimentChart: false,
    });
    const [emailNudge, setEmailNudge] = useState(false);

    useEffect(() => {
        if(type === 'create') {
            setPopulatingExistingFields(false);
        } else {
            fetchExistingProductData(existingProduct.id);
        }
    }, [existingProduct]);

    const handleSourceSelect = (e) => {
        let sourceOptionsClone = JSON.parse(JSON.stringify(sourceOptions));
        sourceOptionsClone[e.target.name] = !sourceOptionsClone[e.target.name];
        setSourceOptions(sourceOptionsClone);
    };

    const handleChartSelect = (e) => {
        let chartOptionsClone = JSON.parse(JSON.stringify(chartOptions));
        chartOptionsClone[e.target.name] = !chartOptionsClone[e.target.name];
        setChartOptions(chartOptionsClone);
    };

    const fetchExistingProductData = async(id) => {
        try {
            let existingProductData = await getProductById(id);
            let productData = existingProductData.content.result[0];
            let sourceOptionsClone = JSON.parse(JSON.stringify(sourceOptions));
            let chartOptionsClone = JSON.parse(JSON.stringify(chartOptions));
            chartOptionsClone.sentimentChart = productData.chartSentiments;
            chartOptionsClone.volumeChart = productData.chartVolumePerDay;
            chartOptionsClone.keywordChart = productData.chartYakeKeywords;

            sourceOptionsClone.facebook = productData.entityCreateFacebook;
            sourceOptionsClone.googleOzmosys = productData.entityCreateGoogleOzmosys;
            sourceOptionsClone.rss = productData.entityCreateRss;
            sourceOptionsClone.instagram = productData.entityCreateInstagram;
            sourceOptionsClone.twitterAccount = productData.entityCreateTwitterAccount;
            sourceOptionsClone.twitterCashtag = productData.entityCreateTwitterCashtag;
            sourceOptionsClone.twitterHashtag = productData.entityCreateTwitterHashtag;
            sourceOptionsClone.twitterMentions = productData.entityCreateTwitterMentions;
            sourceOptionsClone.youtube = productData.entityCreateYoutube;
            setChartOptions(chartOptionsClone);
            setSourceOptions(sourceOptionsClone);
            setEmailNudge(productData.emailNudge);
            setName(productData.name);
            setPopulatingExistingFields(false);
        } catch(err) {
            handleErrors(err);
            console.log(err);
        }
    };

    const onSubmit = async() => {
        try {
            setSubmitting(true);
            setError(null);
            const params = {
                name,
                entityCreateTwitterAccount: sourceOptions.twitterAccount,
                entityCreateTwitterMentions: sourceOptions.twitterMentions,
                entityCreateTwitterCashtag: sourceOptions.twitterCashtag,
                entityCreateTwitterHashtag: sourceOptions.twitterHashtag,
                entityCreateFacebook: sourceOptions.facebook,
                entityCreateRss: sourceOptions.rss,
                entityCreateYoutube: sourceOptions.youtube,
                entityCreateInstagram: sourceOptions.instagram,
                entityCreateGoogleOzmosys: sourceOptions.googleOzmosys,
                chartVolumePerDay: chartOptions.volumeChart,
                chartSentiments: chartOptions.sentimentChart,
                chartYakeKeywords: chartOptions.keywordChart,
                emailNudge,
            };
            type === 'create' ? await createProduct(params) : await updateProductById(existingProduct.id, params);
            await refreshList(true);
            toast.success(type === 'create' ? 'Product successfully created' : 'Product successfully updated');
            toggle();
            setSubmitting(false);
        } catch(err) {
            console.log(err);
            setSubmitting(false);
            if(err.message && err.message === 'This type already use') {
                toast.error('This product type cannot be changed while users are assigned to it.')
            } else {
                handleErrors(err, setError);
            }
        }

    };


    if(populatingExistingFields) return <div className="p-3"><Loader small text="Fetching product data"/></div>;
    return (
        <>
            <ModalBody>
                <InputWithError
                    placeholder="Product name"
                    name="name"
                    value={name}
                    type="text"
                    onChange={setName}
                    errorObj={error}
                    prependIcon={<i className="fas fa-tag"/>}
                    marginBottomClass="mb-3"
                />
                <Row className="mb-4 d-flex">
                    <Col sm={12} md={4}>
                        <div className="product-checkbox-header">Sources</div>
                        <div className="product-checkbox-group">
                            <div className="d-flex pb-2">
                                <CustomInput
                                    id="twitterAccount"
                                    type="checkbox"
                                    name="twitterAccount"
                                    checked={sourceOptions.twitterAccount}
                                    onChange={(e) => handleSourceSelect(e)}
                                />
                                <div>Twitter Accounts</div>
                            </div>
                            <div className="d-flex pb-2">
                                <CustomInput
                                    id="twitterKeyword"
                                    type="checkbox"
                                    name="twitterKeyword"
                                    checked={sourceOptions.twitterKeyword}
                                    onChange={(e) => handleSourceSelect(e)}
                                />
                                <div>Twitter Keywords</div>
                            </div>
                            <div className="d-flex pb-2">
                                <CustomInput
                                    id="twitterHashtag"
                                    type="checkbox"
                                    name="twitterHashtag"
                                    checked={sourceOptions.twitterHashtag}
                                    onChange={(e) => handleSourceSelect(e)}
                                />
                                <div>Twitter Hashtags</div>
                            </div>
                            <div className="d-flex pb-2">
                                <CustomInput
                                    id="twitterMentions"
                                    type="checkbox"
                                    name="twitterMentions"
                                    checked={sourceOptions.twitterMentions}
                                    onChange={(e) => handleSourceSelect(e)}
                                />
                                <div>Twitter Mentions</div>
                            </div>
                            <div className="d-flex pb-2">
                                <CustomInput
                                    id="twitterCashtag"
                                    type="checkbox"
                                    name="twitterCashtag"
                                    checked={sourceOptions.twitterCashtag}
                                    onChange={(e) => handleSourceSelect(e)}
                                />
                                <div>Twitter Cashtags</div>
                            </div>
                            {/*<div className="d-flex pb-2">*/}
                            {/*    <CustomInput*/}
                            {/*        id="blogs"*/}
                            {/*        type="checkbox"*/}
                            {/*        name="blogs"*/}
                            {/*        checked={sourceOptions.blogs}*/}
                            {/*        onChange={(e) => handleSourceSelect(e)}*/}
                            {/*    />*/}
                            {/*    <div>Blogs</div>*/}
                            {/*</div>*/}
                            <div className="d-flex pb-2">
                                <CustomInput
                                    id="facebook"
                                    type="checkbox"
                                    name="facebook"
                                    checked={sourceOptions.facebook}
                                    onChange={(e) => handleSourceSelect(e)}
                                />
                                <div>Facebook</div>
                            </div>
                            <div className="d-flex pb-2">
                                <CustomInput
                                    id="youtube"
                                    type="checkbox"
                                    name="youtube"
                                    checked={sourceOptions.youtube}
                                    onChange={(e) => handleSourceSelect(e)}
                                />
                                <div>YouTube</div>
                            </div>
                            <div className="d-flex pb-2">
                                <CustomInput
                                    id="instagram"
                                    type="checkbox"
                                    name="instagram"
                                    checked={sourceOptions.instagram}
                                    onChange={(e) => handleSourceSelect(e)}
                                />
                                <div>Instagram</div>
                            </div>
                            <div className="d-flex pb-2">
                                <CustomInput
                                    id="rss"
                                    type="checkbox"
                                    name="rss"
                                    checked={sourceOptions.rss}
                                    onChange={(e) => handleSourceSelect(e)}
                                />
                                <div>RSS</div>
                            </div>
                            <div className="d-flex pb-2">
                                <CustomInput
                                    id="googleOzmosys"
                                    type="checkbox"
                                    name="googleOzmosys"
                                    checked={sourceOptions.googleOzmosys}
                                    onChange={(e) => handleSourceSelect(e)}
                                />
                                <div>Google News</div>
                            </div>
                        </div>
                    </Col>
                    <Col sm={12} md={6}>
                        <div className="mb-3">
                            <div className="product-checkbox-header">Charts</div>
                            <div className="product-checkbox-group">
                                <div className="d-flex pb-2">
                                    <CustomInput
                                        id="volumeChart"
                                        type="checkbox"
                                        name="volumeChart"
                                        checked={chartOptions.volumeChart}
                                        onChange={(e) => handleChartSelect(e)}
                                    />
                                    <div>Volume Per Day</div>
                                </div>
                                <div className="d-flex pb-2">
                                    <CustomInput
                                        id="keywordChart"
                                        type="checkbox"
                                        name="keywordChart"
                                        checked={chartOptions.keywordChart}
                                        onChange={(e) => handleChartSelect(e)}
                                    />
                                    <div>Keywords</div>
                                </div>
                                <div className="d-flex pb-2">
                                    <CustomInput
                                        id="sentimentChart"
                                        type="checkbox"
                                        name="sentimentChart"
                                        checked={chartOptions.sentimentChart}
                                        onChange={(e) => handleChartSelect(e)}
                                    />
                                    <div>Sentiments</div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className="product-checkbox-header">Emails</div>
                            <div className="product-checkbox-group">
                                <div className="d-flex pb-2">
                                    <CustomInput
                                        id="emailNudge"
                                        type="checkbox"
                                        name="emailNudge"
                                        checked={emailNudge}
                                        onChange={() => setEmailNudge(prevState => !prevState)}
                                    />
                                    <div>Nudge Email</div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter className="select-fetches-modal-footer">
                <Button style={{color: 'white'}} onClick={toggle}>
                    Cancel
                </Button>
                <SpinnerButton
                    title={type === 'create' ? 'Submit' : 'Save Changes'}
                    submitting={submitting}
                    minWidth="91px"
                    onClick={onSubmit}
                />
            </ModalFooter>
        </>
    );
};

export default ProductForm;
